module.exports = __webpack_public_path__ + "img/logo.134a3c52.svg";